// Overlay grande centrado con el número del countdown. Usado en la
// transición counting → active (3-2-1 antes de empezar reps) y en la
// transición calibracion → counting (post baseline capture exitoso).
// La cámara y la pose siguen activas debajo del overlay — el paciente
// se ve a sí mismo y puede ajustar postura mientras corre el countdown.

interface CountdownOverlayProps {
  value: number;
}

export function CountdownOverlay({ value }: CountdownOverlayProps) {
  return (
    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center pointer-events-none">
      <div
        key={value}
        className="text-white font-bold tabular-nums leading-none animate-in fade-in zoom-in duration-200"
        style={{ fontSize: "min(40vw, 240px)" }}
      >
        {value}
      </div>
    </div>
  );
}
